import React, { useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';
export function ScrollToTop() {
  const {
    pathname
  } = useLocation();
  useLayoutEffect(() => {
    // Run synchronously before paint, and cover all common scroll targets
    const scrollAll = () => {
      try {
        window.scrollTo({
          top: 0,
          left: 0,
          behavior: 'auto'
        });
      } catch {
        window.scrollTo(0, 0);
      }
      if (document.documentElement) document.documentElement.scrollTop = 0;
      if (document.body) document.body.scrollTop = 0;
      // If app is inside a scrollable wrapper (e.g., iframe parent), try that too
      try {
        if (window.parent && window.parent !== window) {
          window.parent.scrollTo(0, 0);
        }
      } catch {
        /* cross-origin parent — ignore */
      }
    };
    scrollAll();
    // Also run after paint in case layout shifts move us
    const raf = requestAnimationFrame(scrollAll);
    return () => cancelAnimationFrame(raf);
  }, [pathname]);
  return null;
}